// extracted by mini-css-extract-plugin
export default {"formWrapper":"DesignAlertsForm_formWrapper__dFWwW","field":"DesignAlertsForm_field__8m9XN","button":"DesignAlertsForm_button__hnH7F","doneText":"DesignAlertsForm_doneText__zpSTu"};